import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import MainLayout from '../layouts/main';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

export default function Router() {
  return useRoutes([
    // Dashboard Routes
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/analytics" replace />, index: true },
        { path: 'analytics', element: <Dashboard /> },
        { path: 'dev', element: <Development /> },

        {
          path: 'campaigns',
          children: [
            { element: <Navigate to="/dashboard/campaigns/list" replace />, index: true },
            { path: 'new', element: <CampForm /> },
            { path: 'edit/:id', element: <CampForm /> },
            { path: 'overview/:id', element: <CampOverview /> },
            { path: 'list', element: <CampaignList /> },
          ],
        },
        {
          path: 'notifications',
          element: <Notification />,
        },
        {
          path: 'threads',
          element: <Thread />,
        },
        {
          path: 'settings',
          element: <Setting />,
        },
        {
          path: 'reports',
          element: <Report />,
        },
        {
          path: 'about',
          element: <About />,
        },
      ],
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        { element: <Navigate to="/license" replace />, index: true },
        { path: 'license', element: <License /> },
        { path: 'available-to-transfer', element: <AvailableToTransfer /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));

const CampaignList = Loadable(lazy(() => import('../pages/campaign/list/CampaignList')));
const CampForm = Loadable(lazy(() => import('../pages/campaign/form/CampForm')));
const CampOverview = Loadable(lazy(() => import('../pages/campaign/overview/CampOverview')));

const Notification = Loadable(lazy(() => import('../pages/notification/Notification')));

const Setting = Loadable(lazy(() => import('../pages/setting/Setting')));
const Thread = Loadable(lazy(() => import('../pages/thread/ThreadList')));

const About = Loadable(lazy(() => import('../pages/about/About')));

const Report = Loadable(lazy(() => import('../pages/report/Report')));

const License = Loadable(lazy(() => import('../pages/License')));
const AvailableToTransfer = Loadable(lazy(() => import('../pages/AvailableToTransfer')));

const NotFound = Loadable(lazy(() => import('../pages/Page404')));
const Development = Loadable(lazy(() => import('../pages/development')));
